import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components/macro';
import {
  fontSize,
  lineHeight,
  media,
  neutral,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';
import * as StaffCommon from '../../common/elements/Staff';
import { EmbedPreview } from './StaffModule';

export const ItemListContainer = styled(StaffCommon.StaffRow)`
  margin: 0;
`;

export const ItemList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
`;

export const ItemContainer = styled.li`
  min-width: 0;
`;

export const ItemAccordion = withStyles({
  root: {
    width: '100%',
    border: `1px solid ${neutral.border}`,
    borderRadius: `${radius.lg} !important`,
    boxShadow: shadow.sm,
    overflow: 'hidden',
    '&:before': {
      display: 'none',
    },
  },
  expanded: {
    margin: '0 !important',
    // clipping would stop the sign off panel sticking to the bottom of the screen
    overflow: 'visible',
  },
})(Accordion);

export const ItemDetails = withStyles({
  root: {
    padding: `0 ${space[4]} ${space[4]}`,
    borderTop: `1px solid ${neutral.border}`,
    paddingTop: space[4],
  },
})(AccordionDetails);

export const ItemSummary = styled.div`
  display: grid;
  /* phones: status sits under the text so the text keeps the full width */
  grid-template-columns: auto minmax(0, 1fr);
  grid-template-areas:
    'index instructions'
    'index check-svg';
  align-items: center;
  gap: ${space[2]} ${space[3]};
  width: 100%;
  padding: ${space[2]} 0;

  & > :last-child {
    grid-area: check-svg;
    justify-self: start;
  }

  ${media.sm`
    grid-template-columns: auto minmax(0, 1fr) auto;
    grid-template-areas: 'index instructions check-svg';

    & > :last-child {
      justify-self: end;
    }
  `}
`;

export const Circle = styled.div`
  grid-area: index;
  text-align: center;
  font-size: ${fontSize.lg};
  font-weight: bold;
  height: 3.6rem;
  width: 3.6rem;
  border-radius: 50%;
  margin: 0;
  background: ${({ theme }) => theme.buttonUpdate};
  color: ${({ theme }) => theme.textLight};
  align-self: center;
  justify-self: start;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ItemIndex = styled.p`
  margin: 0;
`;

export const ModuleItemInstructions = styled.p`
  grid-area: instructions;
  margin: 0;
  font-size: ${fontSize.md};
  line-height: ${lineHeight.normal};
  color: ${({ theme }) => theme.headerColour};
  overflow-wrap: anywhere;
`;
export const CheckSVGContainer = styled.div`
  grid-area: check-svg;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ProgressEmbedPreview = styled(EmbedPreview)`
  height: 40em;
`;

export * from './StaffStudentModules';
